import { render, staticRenderFns } from "./Assign_module.vue?vue&type=template&id=130b3302&"
import script from "./Assign_module.vue?vue&type=script&lang=js&"
export * from "./Assign_module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports